import React from 'react'
import { StatisticsIcon } from '../../images/js/statisticsIcon';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DatePicker from 'react-datepicker';
import { Chart } from 'react-google-charts';
import { refreshCharts, downloadUsage } from '../../actions/userActions';
import ClipLoader from "react-spinners/ClipLoader";
import MoonLoader from "react-spinners/MoonLoader";
import ClockLoader from "react-spinners/ClockLoader";
import * as moment from 'moment'


export const pieData = [
    ["Template", "Refreshed"],
    ["No Data", 1]
];


export const barData = [
    ["Retailer", "Refreshed"],
    ["No Data", 0]
];

export const lineData = [
    ["Month", "Refreshed"],
    ["",0]
];

export const pieOptions = {
    title: "Top Templates",
    width: "100%",
    height: 800,
    chartArea: { width: '65%', height: '70%'}
    
        
};

//backgroundColor: {
//    stroke: 'gray',
//        strokeWidth: 3
//}
export const barOptions = {
    title: "Top Retailers",
    width: "100%",
    height: 1200,
    legend: { position: "none" },
    chartArea: { width: '50%',  height: '80%' },
    hAxis: {
        format: '0',
    }
  
};

export const lineOptions = {
    title: "Total # of Presentations Refreshed",
    width: "100%",
    height: 800,
    legend: { position: "none" },
    chartArea: { width: '65%' },
    vAxis: {
        format: '0',
    },
    gridlines: { count: -1 },
    lineWidth: 5,
};

 export var override = {
    position: "absolute",
    margin: "0px auto",
    borderColor: "gray",
    top: "50%",
    left: "50%",
    color: "white",
    background: "#666666",
    opacity: ".8",
    zIndex: "100"
};


export const color = 'gray';

export const start = new Date();

class Statistics extends React.Component {
    
    state = {
        loading: true,
        startDate: start.setFullYear(start.getFullYear() - 1),
        endDate: new Date(),
        year: new Date(),
        pieData: pieData,
        barDate: barData,
        lineData: lineData
    }

    refresh = (result) => {

        if (result.templates.length > 1) {
            this.setState({ pieData: result.templates });
        } else {
            this.setState({ pieData: pieData });

        }
        if (result.retailers.length > 1) {
            this.setState({ barData: result.retailers });
        } else {

            this.setState({ barData: barData});
        }

        this.setState({ loading: false });

    }

    componentDidMount() {


        refreshCharts(moment(this.state.startDate).format('MM-DD-YYYY'), moment(this.state.endDate).format('MM-DD-YYYY'), 0)
            .then(result => this.refresh(result) );

        refreshCharts(moment(this.state.year).format('YYYY'), moment(this.state.year).format('YYYY'), 1)
            .then(result => this.setState({ lineData: result.monthlyRefreshes, loading: false }));
    }

    setStartDate = (dt) => {
        this.setState({ startDate: dt })
    }

    setEndDate = (dt) => {
        this.setState({ endDate: dt })

    }

    setYear = (dt) => {
        this.setState({ year: dt })
    }

    handleChartRefresh = (event) => {
        event.preventDefault()
        override.top = "50%";
        this.setState({ pieData: pieData, barData: barData, loading: true });

        refreshCharts(moment(this.state.startDate).format('MM-DD-YYYY'), moment(this.state.endDate).format('MM-DD-YYYY'), 0)
            .then(result => this.refresh(result));
    
    };

    handleChartRefresh2 = (event) => {
        event.preventDefault()
        override.top = "90%";
        this.setState({ lineData: lineData, loading: true });

        refreshCharts(moment(this.state.year).format('YYYY'), moment(this.state.year).format('YYYY'), 1)
            .then(result => this.setState({ lineData: result.monthlyRefreshes, loading: false }));

        };

    handleDownload = (event) => {
        event.preventDefault();
        override.top = "50%";
        this.setState({ loading: true });
        downloadUsage(moment(this.state.startDate).format('MM-DD-YYYY'), moment(this.state.endDate).format('MM-DD-YYYY'))
            .then(result => this.setState({ loading: false }));

    };

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    render() {
        return (<div className="mainWrapper">
            <div className="bodyPart">
                <div className="contentWrapper">
                    <ClockLoader color={color} loading={this.state.loading} cssOverride={override} size={200} cs />

                    <h2 className="pageHead">
                        <StatisticsIcon /><span className="mainTitleBox">BI Cloud Statistics</span>
                    </h2>                  
                            <div className="chartselect">
                        Start Date &nbsp;&nbsp;
                                <DatePicker portalId="root-portal" minDate={new Date('1/1/2020')} selected={this.state.startDate} onSelect={this.setStartDate} showPopperArrow={false}
                            placeholderText="Select a date" dateFormat="MM/dd/yyyy" wrapperClassName="datepicker" className="datepicker-input" onChangeRaw={this.handleDateChangeRaw} />

                                 End Date &nbsp;&nbsp;
                                <DatePicker portalId="root-portal" minDate={new Date('1/1/2020')} selected={this.state.endDate} onSelect={this.setEndDate} showPopperArrow={false}
                            placeholderText="Select a date" dateFormat="MM/dd/yyyy" wrapperClassName="datepicker" className="datepicker-input" onChangeRaw={this.handleDateChangeRaw}/>

                   
                                <button type="submit" className="btn" onClick={(e) => this.handleChartRefresh(e)}>Refresh Charts</button>
                                &nbsp;&nbsp;
                                <button type="submit" className="btn" onClick={(e) => this.handleDownload(e)}>Download Usage Report</button>
                  
                       </div>
                            <div>
                                <Chart
                                    chartType="PieChart"
                                    data={this.state.pieData}
                                    options={pieOptions}
                                />
                                <Chart
                                    chartType="BarChart"
                                    data={this.state.barData}
                                    options={barOptions}
                                />
                            </div>                  
                            <br/><br/>
                    <div className="chartselect2">

                           <div className="chart2">
                            Select Year &nbsp;&nbsp;
                              <DatePicker disabledKeyboardNavigation minDate={new Date('1/1/2020')} selected={this.state.year} onSelect={this.setYear} showPopperArrow={false}
                                placeholderText="Select Year" dateFormat="yyyy" showYearPicker wrapperClassName="datepicker" className="datepicker-input" onChangeRaw={this.handleDateChangeRaw} />
                                
                             </div>
                            
                              <button type="submit" className="btn" onClick={(e) => this.handleChartRefresh2(e)}>Refresh Chart</button>
                          
                     </div>

                            <div>
                                <Chart
                                    chartType="LineChart"
                                    data={this.state.lineData}
                                    options={lineOptions}
                                />

                            </div>


                </div>
            </div>
        </div>)

    }
}

export default Statistics